export const faqSectionContent = {
  faqTitleId: 'faqs-title',
  faqTitle: 'FAQs',
  moreInfoText: 'Have more questions?',
  moreInfoDataItemName: 'have-more-questions-link',
  viewFullTermsAndConditions:
    'View the full terms and conditions of our referral scheme.',
  onlyReferFriendFAQs: 'These FAQs are about our referrals scheme only.',
  viewFAQsOnNetwork: 'View FAQs about our network.',
}
